import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-03/lesson-29/task-01";

const task: Slide = {
  title: "Which statements are correct?",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
